import { Toaster } from 'react-hot-toast';
import React from 'react';

interface ToastProviderProps {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <Toaster
        containerStyle={{
          top: 20,
          right: 20,
          zIndex: 9999999,
        }}
        toastOptions={{
          // Styling for all toasts
          style: {
            background: '#333',
            color: '#fff',
          },
          // Customize specific toast types
          success: {
            duration: 3000,
            style: {
              background: 'green',
            },
          },
          error: {
            duration: 4000,
            style: {
              background: 'red',
            },
          },
        }}
      />
    </>
  );
};

